import {Link} from 'react-router-dom'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

import Grid from '../../../../designSystem/helpers/Grid'

const LOGO_HEIGHT = 32
export const FULL_WIDTH_CENTER_GRID_HEIGHT = 62

export const HeaderElement = styled('header')(
  ({theme}) => css`
    z-index: 4;
    position: relative;
    background-color: ${theme.colors.headerBgPrimary};
  `
)

export const HeaderGrid = styled(Grid)(
  () => css`
    height: 80px;
    position: relative;
    z-index: 1;
  `
)

export const SideGrid = styled(Grid)`
  flex: 1 1;
  z-index: 0;
  align-items: center;
`

export const CenterGrid = styled(Grid)`
  flex: 0 0 auto;
  z-index: 1;
`

export const FullWidthCenterGrid = styled(Grid)`
  height: ${FULL_WIDTH_CENTER_GRID_HEIGHT}px;
  width: 100%;
`

const mirror = () => css`
  /* @mirror */
`

export const ButtonElement = styled('button')`
  display: inline-flex;
  background: none;
  border: none;
  outline: none;
`

const backButtonBaseStyles = ({theme}) => css`
  margin-left: -${theme.layout.spacing.s400}px;
  padding: ${theme.layout.spacing.s400}px;
  color: ${theme.colors.backButtonColorPrimary};
`

export const BackButtonElement = styled(ButtonElement)(
  backButtonBaseStyles,
  mirror
)

const logoStyles = () => css`
  height: ${LOGO_HEIGHT}px;
  display: block;
`

export const LogoLinkElement = styled(Link)(logoStyles)
export const LogoElement = styled('div')(logoStyles)
export const LogoAnchorElement = styled('a')(logoStyles)

export const HeaderControlsWrapper = styled('div')(
  ({theme}) => css`
    text-align: right;
    position: relative;
    z-index: 11;
    margin: ${theme.layout.spacing.s200}px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  `
)

export const UserControlWrapper = styled('div')(
  () => css`
    display: inline-block;
    vertical-align: top;
    margin-left: -1px;
    position: relative;
  `
)

export const PreferencesWidgetWrapper = styled('div')(
  ({theme}) => css`
    margin-right: ${theme.layout.spacing.s300}px;
  `
)
